import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "next-i18next";

import Button from "@/shared/components/Button/Button";
import { getSubsAddUrl, getSubsEditUrl } from "@/shared/utils/url/url";
import IconView from "@/shared/components/IconView/IconView";

import { SubscriptionsDatePicker } from "@/components/subscriptions/SubscriptionsDatePicker";
import { useSubscriptionsContext } from "@/contexts/subscriptions";
import DateSwitcher from "@/shared/components/DateSwitcher/dateSwitcher/DateSwitcher";
import { formatServerDateToJSDate } from "@/shared/utils/date";

import EgwWebFont from "src/assets/EgwWebFont";

import styles from "./subscriptions.module.scss";

const SubsTopPanel = ({ onDateChange }) => {
  const { t } = useTranslation();
  const { subscriptions, date } = useSubscriptionsContext();

  return (
    <div className={styles["subs-top-panel"]}>
      <DateSwitcher
        SubscriptionsDatePicker={SubscriptionsDatePicker}
        date={formatServerDateToJSDate(date)}
        onDateChange={onDateChange}
      />
      <div className={styles["subs-top-panel-actions"]}>
        <Button
          rootTagName={"a"}
          href={getSubsAddUrl()}
          target="_blank"
          title={t("subscriptions_add")}
          className={styles["subs-top-panel-action"]}>
          <IconView icon={EgwWebFont["add-subscription"]} />
        </Button>
        <Button
          rootTagName={"a"}
          href={getSubsEditUrl()}
          target="_blank"
          title={t("subscriptions_edit")}
          className={styles["subs-top-panel-action"]}
          disabled={!subscriptions?.length}>
          <IconView icon={EgwWebFont.edit} />
        </Button>
      </div>
    </div>
  );
};

SubsTopPanel.propTypes = {
  onDateChange: PropTypes.func,
};

export default SubsTopPanel;
